// extracted by extract-css-chunks-webpack-plugin
module.exports = {"list":"list-uByaTkpb","img":"img-1seAoThW"};